import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../core/auth/services/auth.service';
import {
  IProfile,
  INewUser,
  IUserChangesResponse,
  ISessionToken,
  IUser,
} from '../../models';
import config from '../../../config';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  apiUrl = config.API_GATEWAY_ENDPOINT;
  prid = '';
  userCache: IProfile | null = null;

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService,
  ) {
    this.authService.amplifyGetUserSession().forEach((session: any) => {
      this.prid = this._extractPridFromSession(session);
    });
  }

  async fecthUser(): Promise<IProfile> {
    if (this.userCache) {
      return this.userCache;
    }

    try {
      const [response] = await lastValueFrom(
        this.http.get<IProfile[]>(`${this.apiUrl}/user/projects/${this.prid}`),
      );
      // Save to cache
      this.userCache = response;
      return response;
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  }

  async fetchUsers(): Promise<IUser[]> {
    try {
      const response = await lastValueFrom(
        this.http.get<IUser[]>(`${this.apiUrl}/users`),
      );
      return response;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  }

  async createUser(user: INewUser): Promise<IUserChangesResponse> {
    try {
      const response = await lastValueFrom(
        this.http.post<IUserChangesResponse>(`${this.apiUrl}/users`, user),
      );
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updateUser(user: INewUser): Promise<IUserChangesResponse> {
    try {
      const response = await lastValueFrom(
        this.http.put<IUserChangesResponse>(`${this.apiUrl}/users`, user),
      );
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  _extractPridFromSession(session: ISessionToken): string {
    if (session?.tokens?.accessToken?.payload?.username) {
      const pridToken = session.tokens.accessToken.payload.username;
      const email = pridToken.split('@')[0];
      return email.split('_')[1] || email;
    }
    return '';
  }
}
